export default __webpack_public_path__ + "static/campaign_header.png";